import $http from "../../../axios-instance";

/**
 * Cargar las Unificación de componentes.
 *
 * @param Object { commit }
 * @param Object { page, per_page }
 * @returns
 */
export async function getAll({ commit }, { page, per_page }) {
    commit("dashboard/load", true, { root: true });
    commit("setUnifyComponents", []);

    try {

        if (!page) page = 1
        if (!per_page) per_page = 10  

        const { data: response } = await $http.get(
            `/cas/unify-components?page=${page}&per_page=${per_page}`
        );

        commit("setUnifyComponents", response.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Consultar todos los componentes.
 *
 * @param Object { commit }
 * @param Object params
 * @return {Array}
 */
export async function searchComponentsPrimaries({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit("setComponentsToPrimaries", []);

    try {
        
      const { data: response } = await $http.get("cas/lista-componentes", { params });

      commit("setComponentsToPrimaries", response.data);

    } catch (error) {
      if (this.$vue.$alertErrorsCallback(error)) return;
      this.$vue.$alertError(error.message);
    } finally {
      commit("dashboard/load", false, { root: true });
    }
}

/**
 * Crear unificación de componentes.
 *
 * @param Object { state, commit }
 * @param Object payload
 * @returns
 */
export async function store({ dispatch, commit }, payload) {
    commit("dashboard/load", true, { root: true });

    try {
        const { data: response } = await $http.post(
            "/cas/unify-components",
            payload
        );

        dispatch("getAll", { page: 1, per_page: 10 });

        this.$vue.$alertSuccess(response.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error))
        this.$vue.$alertError(error.message);

        return false;
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Consultar productos asociados a componentes.
 *
 * @param Object { state, commit }
 * @param Array prodComponentsIds
 * @returns
 */
export async function getProductsAssignedToComponentsIds({ state, commit }, prodComponentsIds) {
    commit("dashboard/load", true, { root: true });
    commit("setCurrentUnifyComponent", { 
        ...state.currentUnifyComponent, 
        affected_products: [],
        affected_dangers: []
    });

    try {
        
        const { data: response } = await $http.get(
            `/cas/unify-components/products-assigned-to-components-ids`,
            { params: prodComponentsIds }
        );

        commit("setCurrentUnifyComponent", {
            ...state.currentUnifyComponent,
            affected_products: response.data.products,
            affected_dangers: response.data.dangers
        });

    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}